module.exports = __webpack_public_path__ + "img/nextshop-app.c10a8b48.svg";